import "../assets/css/--component-global-loader.css"
function GlobalLoader({isLoading}) {
    return (
        isLoading ?
        <div className="process-loading">
            <p className="fs-18 text-white">Processing...</p>
            <div className="process-loading-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div> : null
    )
}
export default GlobalLoader;